const envCookiePrefix = process.env.COOKIE_PREFIX || "";

export const SF_COOKIE_USERNAME = `${envCookiePrefix}sf_username`;
export const SF_COOKIE_ACCESS_TOKEN = `${envCookiePrefix}sf_accessToken`;
export const SF_COOKIE_AUTH_TOKEN_EXPIRES_IN = `${envCookiePrefix}sf_authTokenExpiresIn`;
export const SF_COOKIE_REFRESH_TOKEN = `${envCookiePrefix}sf_refreshToken`;
export const SF_COOKIE_REMEMBER_ME = `${envCookiePrefix}sf_rememberMe`;
